<div class="firstDiv"><h5 class="ShippingHeading">PRIVACY POLICY</h5></div>

<div  class="secondDiv">
    <p class="shippingPara">Privacy Policy
        At FRRANKY, your privacy matters to us. We are committed to protecting your personal information and being transparent about how we collect, use, and safeguard it.<br>
    </p><h5 class="SubHeadings">
    1. Information We Collect</h5>
   <p class="para"> When you visit or make a purchase on our website, we may collect the following information:
    Personal Information: Name, email address, shipping and billing address, phone number, and payment details.
    Account Information: If you create an account, we collect your username, password, and other account preferences.


    Device Information: IP address, browser type, device type, and cookies for analytics and site functionality.
    
    
    Order History & Communication: Details of your purchases and any communication with our customer service team.    
</p>
    
    
    <h5 class="SubHeadings">2. How We Use Your Information</h5>
    <p class="para">We use your data to:
        Process orders, payments, and deliveries
        
        
        Provide customer support and respond to inquiries
        
        
        Send order updates, promotions, and marketing content (if you opt in)
        
        
        Improve our website functionality and user experience
        
        
        Prevent fraud and ensure security</p>
    
   <h5 class="SubHeadings">3. Sharing Your Information</h5> 
   <p class="para">  We never sell your data. We only share your information with:
    Trusted service providers (e.g., payment processors, courier services, marketing platforms) to fulfill your orders and provide services
    
    
    Legal authorities, only when required by law or for fraud prevention
    
    
   <h5 class="SubHeadings">4. Your Rights & Choices</h5> 
   <p class="para"> You have the right to:
    Access, update, or delete your personal information
    
    
    Opt out of promotional emails at any time
    
    
    Request data portability or restriction of use under applicable laws
    
   <h5 class="SubHeadings">5. Cookies & Tracking</h5>
   <p class="para">We use cookies to:
    Remember your preferences
    
    
    Analyze website traffic
    
    
    Personalize your shopping experience
    
    
    You can manage cookies through your browser settings.</p>
    
    
    
    <h5 class="SubHeadings">6. Data Security</h5>
    <p class="para"> We use encryption, secure servers, and regular security audits to protect your data. While we take every precaution, no method of transmission over the internet is 100% secure.
    </p>

    <h5 class="SubHeadings">7. Children's Privacy</h5>
    <p class="para">Our website is not intended for children under 13. We do not knowingly collect data from minors.
    </p>

    <h5 class="SubHeadings">8. Changes to This Policy</h5>
    <p class="para"> We may update this Privacy Policy from time to time. All changes will be posted on this page with a revised effective date.
    </p>
    
    
    
   <h5 class="SubHeadings">9. Contact Us</h5>
   <p class="para">  9. Contact Us
    If you have any questions or concerns, feel free to contact us:
     📧 Email: support@frranky.com<br>
     📞Contact No.: 9811308821</p>
    </div>
    
